export default __webpack_public_path__ + "static/media/Team4.fc173162.png";